@if (isLarge) {
  <div class="large" [ngClass]="[largeBgColor]"></div>
} @else {
  <div class="spinner-wrapper" [ngClass]="{ 'is-primary': isPrimaryColor }">
    <span class="smooth spinner"></span>
  </div>
}
